import Loadable from "@loadable/component";

const ErrorPage = Loadable(
  () => import(/* webpackChunkName: "error_page" */ "./errorPage")
);

export default ErrorPage;
